import React, { useState, useEffect } from "react";

import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import PageHeading from "../../components/pageHeading/PageHeading";
import { SearchIcon } from "../../components/Icons";
import "./faq.scss";
import { getContent, getAllContent } from "../../services/auth.service";
import { Card, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { setLoader } from "../../slice/commonSlice";
import { useDispatch } from "react-redux";

export const Faq = () => {
  const [faqs, setfaqs] = useState([]);
  const [contentId, setContentId] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredFaqs, setFilteredFaqs] = useState();
  const dispatch = useDispatch();

  const getallcontent = async () => {
    try {
      await dispatch(setLoader(true));
      const result = await getAllContent();
      if (result?.status === 200) {
        const searchObject = result?.data?.find((data) => data?.slug == "faq");
        setContentId(searchObject?._id);
        await dispatch(setLoader(false));
      } else {
        await dispatch(setLoader(false));
      }
    } catch (e) {
      await dispatch(setLoader(true));
    }
  };

  const handleFAQs = (faqs) => {
    const modifiedFaqs = faqs?.map((faq) => {
      if (faq.question === "What is the Privacy Policy?") {
        faq.answer = (
          <>
            {faq.answer}
            <p>
              For more details, you can check our{" "}
              <Link to="/privacypolicy">Privacy Policy</Link>.
            </p>
          </>
        );
      }
      return faq;
    });
    setFilteredFaqs(modifiedFaqs);
    setfaqs(modifiedFaqs);
  };

  const getcontent = async () => {
    try {
      const paylaod = { _id: contentId };

      const result = await getContent(paylaod);
      if (result?.status === 200) {
        await handleFAQs(result?.data?.content);
        await dispatch(setLoader(false));
      } else {
        await dispatch(setLoader(false));
      }
    } catch (e) {
      await dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    getallcontent();
  }, []);

  useEffect(() => {
    getcontent();
  }, [contentId]);

  useEffect(() => {
    const filteredResults = faqs.filter((faq) =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredFaqs(filteredResults);
  }, [searchQuery]);

  return (
    <>
      <Header />
      <PageHeading title="FAQS" />
      <div className="main-container">
        <div className="faq-container">
          <div className="faq-search-wrap">
            {/* <div className='faq-search-title'>How can we help you?</div> */}
            <div className="faq-search-title">Ask us a question</div>
            <div className="faq-search">
              <div className="icon-wrap">
                <SearchIcon />
              </div>
              <Form.Control
                type="text"
                placeholder="Search for help guides"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
          {/* <Accordion  alwaysOpen>
            {filteredFaqs?.map((faq, index) => (
              <Accordion.Item  key={index} eventKey={index.toString()}>
                <Accordion.Header>{faq?.question}</Accordion.Header>
                <Accordion.Body>{faq?.answer}</Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion> */}
          {filteredFaqs?.length > 0 ? (
            filteredFaqs.map((faq, index) => (
              <div className="accordion-item" key={index}>
                <Card>
                  <Card.Body>
                    <h2
                      className="accordion-header accordion-button"
                      style={{
                        marginTop: "15px",
                        marginBottom: "15px",
                        fontSize: "15px",
                      }}
                    >
                      Q{index + 1}: {faq?.question}
                    </h2>
                    <div
                      className="accordion-body"
                      style={{ marginBottom: "5px" }}
                    >
                      Ans: {faq?.answer}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))
          ) : (
            <div style={{ marginTop: "15px", fontSize: "15px", color: "red" }}>
              No FAQs found.
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};
